import { ReportsGroup } from './reports-group-component'

export default ReportsGroup
export * from './reports-group-component'
